import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { EventStaffModalComponent } from './event-staff-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputMaskModule } from '@ngneat/input-mask';

@NgModule({
  declarations: [EventStaffModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    InputMaskModule,
  ],
  exports: [EventStaffModalComponent]
})
export class EventStaffModalCommonPageModule { }
